import { IIcon } from './iconConstants'
const NoBookingsIcon = (props: IIcon) => {
  return (
    <svg width='41' height='40' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M28.17 3.561a1.228 1.228 0 0 1 1.227 1.228v1.46h2.48a4.095 4.095 0 0 1 4.087 4.09v9.216a1.229 1.229 0 0 1-2.457 0V10.34a1.635 1.635 0 0 0-1.63-1.634h-2.48v.617a1.228 1.228 0 0 1-2.456 0v-.617h-7.694v.617a1.228 1.228 0 0 1-2.456 0v-.617H9.097v.617a1.23 1.23 0 0 1-2.096.868c-.23-.23-.36-.543-.36-.868v-.617h-2.48a1.636 1.636 0 0 0-1.63 1.633v19.81a1.635 1.635 0 0 0 1.63 1.63h18.065a1.229 1.229 0 0 1 0 2.456H4.162a4.095 4.095 0 0 1-4.087-4.087V10.34a4.095 4.095 0 0 1 4.087-4.09H6.64V4.79a1.229 1.229 0 0 1 2.456 0v1.46h7.695V4.79a1.23 1.23 0 0 1 2.096-.868c.23.23.36.542.36.868v1.46h7.694V4.79A1.23 1.23 0 0 1 28.17 3.56z'
        fill={props?.fill}
        stroke={props?.stoke}
        strokeWidth='.15'
      />
      <path
        d='M8.831 13.723a1.228 1.228 0 0 1 0 2.457H6.905a1.23 1.23 0 0 1 0-2.457h1.926zM18.982 13.723a1.228 1.228 0 0 1 0 2.457h-1.926a1.23 1.23 0 0 1-.868-2.097c.23-.23.542-.36.868-.36h1.926zM29.132 13.723a1.229 1.229 0 0 1 0 2.457h-1.926a1.23 1.23 0 0 1-.868-2.097c.23-.23.542-.36.868-.36h1.926zM8.831 19.352a1.228 1.228 0 0 1 0 2.456H6.905a1.23 1.23 0 0 1-.868-2.097c.23-.23.543-.36.868-.36h1.926zM18.982 19.352a1.228 1.228 0 0 1 0 2.456h-1.926a1.23 1.23 0 0 1-.868-2.097c.23-.23.542-.36.868-.36h1.926zM8.831 24.98a1.228 1.228 0 0 1 0 2.456H6.905a1.23 1.23 0 0 1-.868-2.097c.23-.23.543-.359.868-.359h1.926zM18.982 24.98a1.228 1.228 0 0 1 0 2.456h-1.926a1.23 1.23 0 0 1-.868-2.097c.23-.23.542-.359.868-.359h1.926z'
        fill={props?.fill}
        stroke={props?.stoke}
        strokeWidth='.15'
      />
      <rect x='20.598' y='17.604' width='19.668' height='19.668' rx='9.834' fill='#fff' />
      <path
        d='M30.432 19.587a7.853 7.853 0 1 1 0 15.705 7.853 7.853 0 0 1 0-15.705zm0 1.655a6.197 6.197 0 1 0 0 12.394 6.197 6.197 0 0 0 0-12.394zm0 8.882a.827.827 0 1 1 0 1.653.827.827 0 0 1 0-1.653zm0-7.025a.827.827 0 0 1 .828.828v4.214a.829.829 0 0 1-1.655 0v-4.214a.828.828 0 0 1 .827-.828z'
        fill={props?.fill}
        stroke={props?.stoke}
        strokeWidth='.25'
      />
    </svg>
  )
}
export default NoBookingsIcon
